import type { ContextDocumentParsingWsEvent } from 'modules/estimation/types';

type Listener = (payload: ContextDocumentParsingWsEvent) => void;

const listeners = new Set<Listener>();

export const contextDocumentEvents = {
  on(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  emit(payload: ContextDocumentParsingWsEvent): void {
    listeners.forEach((listener) => {
      try {
        listener(payload);
      } catch (e) {
        console.error('contextDocumentEvents listener failed', e);
      }
    });
  },
};
